<template>
  <el-dialog
    class="coupon-common dialog-common"
    :title="title"
    :visible.sync="show"
    width="400px"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    @close="close"
  >
    <div class="list" :class="{ 'order-list': couponDlg.type == 3 }">
      <div class="item" v-for="(item, index) in couponList" :key="index">
        <div class="price">
          <Currency class="currency"></Currency>
          <span class="discounted_price">
            {{ item.discounted_price | price }}元
          </span>
          <span class="full_reduction">
            满{{ item.full_reduction | price }}可用
          </span>
        </div>
        <div class="scope" v-if="item.dis_type == 1">
          {{
            item.scope_type == 1
              ? "全部课程"
              : item.scope_type == 2
              ? "指定课程分类"
              : "指定课程"
          }}可用
        </div>
        <div class="scope" v-else-if="item.dis_type == 4">
          {{
            item.scope_type == 1
              ? "全部约课"
              : item.scope_type == 2
              ? "指定讲师"
              : ""
          }}
        </div>
        <div class="scope" v-else-if="item.dis_type == 2">
          {{
            item.scope_type == 1
              ? "全部实物商品"
              : item.scope_type == 2
              ? "指定实物商品分类"
              : "指定实物商品"
          }}
        </div>
        <div class="scope" v-else-if="item.dis_type == 5">
          {{
            item.scope_type == 1
              ? "全部班级"
              : item.scope_type == 2
              ? "指定班级教学分类"
              : item.scope_type == 3
              ? "指定班级"
              : "指定班级年级"
          }}
        </div>
        <div class="scope" v-else-if="item.dis_type == 6">
          {{
            item.scope_type == 1
              ? "全部电子书"
              : item.scope_type == 2
              ? "指定电子书分类"
              : "指定电子书"
          }}
        </div>
        <div class="bottom">
          <div class="time">
            {{ getTime(item) }}
          </div>
          <!-- <a class="btn" @click="getCoupon(item.id)" v-if="item.is_draw == 0">
            立即领取
          </a>
          <a class="btn" @click="goToUsePage(item)" v-else>立即使用</a> -->
        </div>
      </div>
    </div>
    <div class="btn">
      <button @click="allGet()">{{ btn }}</button>
    </div>
  </el-dialog>
</template>

<script>
export default {
  name: "CouponDlg",
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      show: false,
      titleArr: ["您的优惠已到账", "您的专属优惠券", "支付优惠"],
      title: "您的优惠已到账",
      btnArr: ["已知晓", "一键领取", "立即领取"],
      btn: "已知晓",
      couponList: [],
    };
  },
  watch: {
    visible(val) {
      this.onVisible(val);
    },
    show(val) {
      this.$emit("update:visible", val);
    },
  },
  computed: {
    couponDlg() {
      return this.$store.state.couponDlg;
    },
  },
  created() {
    this.onVisible(this.visible);
  },
  mounted() {},
  methods: {
    // on event
    async onVisible(val) {
      if (!val) {
        return;
      }
      let url = "";
      if (this.couponDlg.type == 1) {
        url = "/api/app/newUserCoupon";
      } else if (this.couponDlg.type == 2) {
        url = "/api/app/loginCoupon";
      } else {
        url = `/api/app/orderCoupon/${this.couponDlg.orderId}`;
      }
      const res = await this.$http.get(url);
      if (res.length) {
        this.title = this.titleArr[this.couponDlg.type - 1];
        this.btn = this.btnArr[this.couponDlg.type - 1];
        this.couponList = res;
        this.show = val;
      } else if (this.couponDlg.type == 2) {
        // 处理登录优惠券为空 新用户优惠券不为空状态
        this.close();
      } else {
        let obj = JSON.parse(JSON.stringify(this.couponDlg));
        obj.show = false;
        this.$store.commit("setCouponDlg", obj);
      }
    },
    getTime(item) {
      let time = "有效期：";
      if (item.valid_type == 1) {
        time += item.valid_day + "天";
      } else {
        time +=
          new Date(item.valid_start * 1000).format("yyyy/MM/dd") +
          "-" +
          new Date(item.valid_end * 1000).format("yyyy/MM/dd");
      }
      return time;
    },
    async getCoupon(id) {
      let data = await this.$http.get("/api/app/userGetCoupon/" + id);
      this.couponList.filter(c => c.id == id)[0].is_can_get =
        data.is_continue_get == 1 ? 1 : 0;
      this.$message({
        message: "领取成功",
        type: "success",
      });
    },
    goToUsePage(item) {
      this.$services.CouponService.goToUsePage(item);
    },
    async allGet() {
      if (this.couponDlg.type == 1) {
        // this.$message({
        //   message: "领取成功",
        //   type: "success",
        // });
        this.close();
      } else {
        await this.$http.post("/api/app/batchUserGetCoupon", {
          coupon: this.couponList
            .map(it => {
              return it.id;
            })
            .join(","),
        });
        this.$message({
          message: "领取成功",
          type: "success",
        });
        this.close();
      }
    },
    close() {
      this.show = false;
      let obj = JSON.parse(JSON.stringify(this.couponDlg));
      obj.show = false;
      this.$store.commit("setCouponDlg", obj);
      if (this.couponDlg.type == 2) {
        setTimeout(() => {
          this.$store.commit("setCouponDlg", {
            show: true,
            type: 1,
          });
        }, 500);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.coupon-common {
  /deep/ .el-dialog {
    .el-dialog__header {
      display: flex;
      justify-content: space-between;
      align-items: center;
      height: 50px;
      margin: 0;
      padding: 0 16px;
      .el-dialog__title {
        font-size: 14px;
        font-family: PingFang SC, PingFang SC-Semibold;
        font-weight: 600;
        text-align: left;
        color: #17233d;
        line-height: 20px;
      }
      .el-dialog__headerbtn {
        position: static;
        height: 24px;
        width: 24px;
        i {
          color: #666;
        }
      }
    }
    .el-dialog__body {
      padding: 0;
      border-top: 1px solid #e9ebed;
      overflow: hidden;
      max-height: unset !important;
      &::-webkit-scrollbar {
        width: 0 !important;
      }
      & {
        -ms-overflow-style: none;
      }
      & {
        overflow: -moz-scrollbars-none;
      }
      .list {
        height: 424px;
        padding: 16px 20px 0;
        box-sizing: border-box;
        max-height: 424px;
        overflow-y: scroll;
        overflow-x: hidden;
        &::-webkit-scrollbar {
          width: 0 !important;
        }
        & {
          -ms-overflow-style: none;
        }
        & {
          overflow: -moz-scrollbars-none;
        }
        &.order-list {
          height: auto;
        }
        .item {
          width: 360px; /*设为固定值*/
          height: 120px;
          margin-bottom: 16px;
          padding: 0 18px;
          background: url(~@stu/images/index/coupon-bg-active.png) no-repeat
            center/360px 120px;
          box-sizing: border-box;
          .price {
            padding-top: 10px;
          }

          .currency {
            font-weight: 500;
            font-family: PingFang SC, PingFang SC-Medium;
            background: linear-gradient(157deg, #ff7940 0%, #ffcf4f 100%);
            -webkit-background-clip: text;
            -webkit-text-fill-color: transparent;
            text-shadow: 0px 2px 4px 0px rgba(255, 157, 70, 0.1);
            font-size: 16px;
          }

          .discounted_price {
            display: inline-block;
            margin: 0 6px 0 3px;
            font-size: 32px;
            font-family: PingFang SC, PingFang SC-Semibold;
            font-weight: 600;
            background: linear-gradient(157deg, #ff7940 0%, #ffcf4f 100%);
            -webkit-background-clip: text;
            -webkit-text-fill-color: transparent;
            text-shadow: 0px 2px 4px 0px rgba(255, 157, 70, 0.1);
            line-height: 45px;
          }
          .full_reduction {
            display: inline-block;
            font-size: 14px;
            color: #666666;
            line-height: 20px;
            font-weight: 400;
          }
          .scope {
            margin-top: 5px;
            font-size: 13px;
            font-weight: 400;
            color: #666;
            line-height: 18px;
          }
          .bottom {
            display: flex;
            justify-content: space-between;
            align-items: center;
            margin-top: 15px;
            .time {
              font-size: 12px;
              font-weight: 400;
              color: #ffffff;
              line-height: 17px;
            }
            .btn {
              font-size: 16px;
              font-weight: 400;
              color: #ffffff;
              line-height: 22px;
              text-shadow: 0px 2px 4px 0px rgba(255, 157, 70, 0.1);
            }
            a.btn {
              cursor: pointer;
            }
          }
        }
      }
      .btn {
        display: flex;
        justify-content: center;
        align-items: center;
        width: 400px;
        height: 56px;
        background: #ffffff;
        border-radius: 0px 8px 8px 0px;
        box-shadow: 0px -4px 20px 0px rgba(120, 144, 191, 0.1);
        button {
          width: 120px;
          height: 32px;
          background: linear-gradient(177deg, #ff7940 22%, #ffc84f 100%);
          border-radius: 16px;
          box-shadow: 0px 2px 4px 0px rgba(255, 157, 70, 0.4);
          border: none;
          outline: none;
          text-align: center;
          font-size: 14px;
          font-family: PingFang SC, PingFang SC-Regular;
          font-weight: 400;
          color: #ffffff;
          line-height: 32px;
          cursor: pointer;
        }
        .disabled {
          width: 120px;
          height: 32px;
          background: linear-gradient(178deg, #d1d1d1 0%, #e1e1e1 100%);
          border-radius: 16px;
          box-shadow: 0px 2px 4px 0px rgba(202, 202, 202, 0.4);
          border: none;
          outline: none;
          text-align: center;
          font-size: 14px;
          font-family: PingFang SC, PingFang SC-Regular;
          font-weight: 400;
          color: #ffffff;
          line-height: 32px;
        }
      }
    }
  }
}
</style>
